import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
// 用户相关
import { handleBuryingEvent } from '@/hooks';
var user = null;
if (localStorage.getItem('user')) {
  user = JSON.parse(localStorage.getItem('user'));
}
var state = {
  user: user
};
var mutations = {
  setUser: function setUser(state, payload) {
    var user = payload.user;
    state.user = user;
    handleBuryingEvent('config', {
      user_unique_id: user === null || user === void 0 ? void 0 : user.id,
      big_activity_login_status: '登录'
    });
    localStorage.setItem('user', JSON.stringify(user));
  }
};
var getters = {
  getUser: function getUser(state) {
    return state.user;
  }
};
export default {
  state: state,
  mutations: mutations,
  getters: getters
};